"use strict";

require("core-js/modules/es.object.from-entries.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseUrlQuery = parseUrlQuery;

function parseUrlQuery(url) {
  var res = new URL(url);
  return Object.fromEntries(res.searchParams.entries());
}